module.exports = __webpack_public_path__ + "img/pink-blue.19861a08.jpg";